export default __webpack_public_path__ + "static/media/024-bussiness.e078c57c.png";